import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { t } from 'i18next';

class Footer extends Component {

	render() {
		return (
			<div>
				<footer className="text-center">
					<Link to="/logout">{t('Logout')}</Link>
					<div>&copy; 2018 Jiffy Lube® Service Center {t('All rights reserved.')}</div>
					<div><a href="//tbkcreative.com" target="_blank" rel="noopener noreferrer">tbk Creative | Web Design &amp; Digital Marketing</a></div>
				</footer>
			</div>
		)
	}
}

export { Footer };